import { useState } from "react";
import { faqs } from "@/mocks/home";

const pledges = [
  {
    icon: "ri-file-shield-2-line",
    title: "来源可追溯",
    text: "只采纳能证明“谁在说话”的碎片；来路不明的说法一律不进正文。",
  },
  {
    icon: "ri-exchange-funds-line",
    title: "翻案会明说",
    text: "结论只属于证据。错了就原条标灰并附更正，把改判理由摊给你看。",
  },
  {
    icon: "ri-time-line",
    title: "带时间轴的现场",
    text: "每条都标注发稿轮次与时刻，第一轮和补充轮并排放置，不偷偷合并。",
  },
];

export default function Trust() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="trust" className="mx-auto max-w-6xl scroll-mt-24 px-4 pt-16 md:px-6 md:pt-24">
      <div className="rounded-lg bg-paper-2 px-5 py-8 ring-1 ring-line md:px-10 md:py-12">
        <div className="flex flex-col lg:flex-row lg:gap-16">
          {/* 承诺栏 */}
          <div className="lg:w-[38%]">
            <p className="text-xs uppercase tracking-[0.2em] text-accent">How we report · 报法与信任</p>
            <h3 className="font-display mt-3 text-2xl font-black leading-snug tracking-tight text-ink md:text-[2rem]">
              911网怎么保证，
              <br />
              你看到的是第一轮？
            </h3>
            <p className="mt-5 text-[15px] leading-7 text-ink/75">
              因为911网不做二手汇总，也不催你相信还没证实的定论。突发消息进来，我们先把原貌收好，再决定要不要、以及多大程度上告诉你。这套报法，就是本站最该被追问的部分。
            </p>

            <div className="mt-8 flex flex-col gap-6">
              {pledges.map((p) => (
                <div key={p.title} className="flex gap-4">
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-soft text-accent-deep">
                    <i className={`${p.icon} text-lg`} />
                  </span>
                  <div>
                    <h5 className="text-[15px] font-semibold text-ink">{p.title}</h5>
                    <p className="mt-1 text-sm leading-6 text-muted">{p.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* FAQ 手风琴 */}
          <div className="mt-10 lg:mt-0 lg:flex-1">
            <div className="flex items-center justify-between border-b border-line pb-3">
              <h4 className="font-display text-lg font-bold text-ink">常见问题 · FAQ</h4>
              <span className="text-xs uppercase tracking-wider text-muted">点开看答案</span>
            </div>
            <div className="divide-y divide-line">
              {faqs.map((f, i) => {
                const open = openIdx === i;
                return (
                  <div key={f.q}>
                    <button
                      type="button"
                      onClick={() => setOpenIdx(open ? -1 : i)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 py-4 text-left"
                    >
                      <span className="text-[15px] font-medium leading-6 text-ink">{f.q}</span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full ring-1 ring-line transition-colors ${open ? "bg-accent text-white ring-accent" : "text-muted"}`}
                      >
                        <i className={`${open ? "ri-subtract-line" : "ri-add-line"} text-[15px]`} />
                      </span>
                    </button>
                    {open && (
                      <p className="pb-5 pr-8 text-sm leading-7 text-muted">{f.a}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}